import { createContext } from "react";

export const ActivityAnimationContext = createContext<{
  live: boolean;
  activityId: string;
} | null>(null);
